import { FooterButton } from './FooterButton';

interface FooterProps {
  backPath?: string;
  nextPath?: string;
  goBack?: boolean;
  goNextText?: string;
}

export function Footer({
  backPath,
  nextPath,
  goBack,
  goNextText = 'Next',
}: FooterProps) {
  return (
    <footer
      id="footer"
      className="w-full bg-white py-8" // bottom-0 absolute -> commented by Chris
    >
      <div className="flex flex-row flex-nowrap justify-between items-center">
        {(backPath || goBack) && (
          <FooterButton path={backPath} text={'Back'} goBack={goBack} />
        )}
        {nextPath && <FooterButton path={nextPath} text={goNextText} />}
      </div>
    </footer>
  );
}
